var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material/styles';
// SETUP COLORS
var GREY = {
    0: '#FFFFFF',
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#454F5B',
    800: '#212B36',
    900: '#161C24'
};
var PRIMARY = {
    lighter: '#C8FFF7',
    light: '#52DECA',
    main: '#009983',
    dark: '#006F5F',
    darker: '#004E43',
    contrastText: '#FFFFFF'
};
var SECONDARY = {
    lighter: '#FFF6DB',
    light: '#FFDF82',
    main: '#B49640',
    dark: '#8C6800',
    darker: '#664C00',
    contrastText: '#FFFFFF'
};
var INFO = {
    lighter: '#CAFDF5',
    light: '#61F3F3',
    main: '#00B8D9',
    dark: '#006C9C',
    darker: '#003768',
    contrastText: '#FFFFFF'
};
var SUCCESS = {
    lighter: '#D3FCD2',
    light: '#77ED8B',
    main: '#22C55E',
    dark: '#118D57',
    darker: '#065E49',
    contrastText: '#ffffff'
};
var WARNING = {
    lighter: '#FFF5CC',
    light: '#FFD666',
    main: '#FFAB00',
    dark: '#B76E00',
    darker: '#7A4100',
    contrastText: GREY[800]
};
var ERROR = {
    lighter: '#FFE9D5',
    light: '#FFAC82',
    main: '#FF5630',
    dark: '#B71D18',
    darker: '#7A0916',
    contrastText: '#FFFFFF'
};
var COMMON = {
    common: {
        black: '#000000',
        white: '#FFFFFF'
    },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    divider: alpha(GREY[500], 0.2),
    action: {
        hover: alpha(GREY[500], 0.08),
        selected: alpha(GREY[500], 0.16),
        disabled: alpha(GREY[500], 0.8),
        disabledBackground: alpha(GREY[500], 0.24),
        focus: alpha(GREY[500], 0.24),
        hoverOpacity: 0.08,
        disabledOpacity: 0.48
    }
};
export function palette(mode) {
    var light = __assign(__assign({}, COMMON), { mode: 'light', text: {
            primary: GREY[900],
            secondary: GREY[700],
            disabled: GREY[500],
            tertiary: GREY[600]
        }, background: {
            paper: '#FFFFFF',
            default: '#FFFFFF',
            neutral: GREY[200]
        }, action: __assign(__assign({}, COMMON.action), { active: GREY[600] }) });
    var dark = __assign(__assign({}, COMMON), { mode: 'dark', text: {
            primary: '#FFFFFF',
            secondary: GREY[500],
            disabled: GREY[600]
        }, background: {
            paper: GREY[800],
            default: GREY[900],
            neutral: alpha(GREY[500], 0.12)
        }, action: __assign(__assign({}, COMMON.action), { active: GREY[500] }) });
    return mode === 'light' ? light : dark;
}
